import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from "../../../../api/axios";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { FormGroup, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";

import AddIcon from "@mui/icons-material/Add";
import ContentCopy from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import "./admin_acgtcards.css";

import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import { url } from "../../../../configlink";

//import ACGTCardPaymentViewDlg from "./ACGTCardPaymentViewDlg";

export default function ACGTCardPaymentHistoryEdit() {
  let [changedData, setChangedData] = useState({});

  let [data, setData] = useState({
    cardNumber: "",
    amount: "",
    cardtype: "",
    ccNumber: "xxxx-xxxx-xxxx-xxxx",
    ccHolder: "",
    ccv: "",
    ccMonth: "",
    ccYear: "",
    billingCompany: "",
    billingAddress: "",
    billingAddress2: "",
    billingCity: "",
    billingState: "",
    billingZip: "",
    billingPhone: "",
    billingFax: "",
    billingEmail: "",
    shipCompany: "",
    shipAddress: "",
    shipAddress2: "",
    shipCity: "",
    shipState: "",
    shipZip: "",
    shipPhone: "",
    shipFax: "",
    shipEmail: "",
    qbRef: "",
    payStatus: "",
  });

  const states = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
  ];

  let loc = useLocation();
  let id = loc.search.split("=")[1];

  useEffect(() => {
    let data = loc.search.split("=")[1];
    console.log(data);
    getAcgtcardHistory(data);
  }, []);

  async function getAcgtcardHistory(x) {
    // try {
    //   const response = await axios.get(
    //     `${url}/api/admin/get_admin_acgtcard_edit_detail`,
    //     {
    //       params: {
    //         id: x,
    //       },
    //     }
    //   );
    //   console.log(response.data);
    //   let card = response.data[0];
    //   setACGTCardData(card);
    // } catch (error) {
    //   console.error(error);
    // }
    console.log(x);
  }

  function updateContent() {
    console.log("update");
  }

  function createRow() {
    console.log("create");
  }

  return (
    <div>
      <div>
        <div>
          <div className="p-2">
            <h1 className="text-2xl font-bold ">ACGT Card Details</h1>
            <div className="border border-black p-2 text-[13px] flex flex-col gap-[5px]">
              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">ACGT Card</p>
                <p className="font-bold">Purchasing by Credit Card</p>
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">ACGT Card#</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.cardNumber}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      cardNumber: e.target.value,
                    });
                    setData({ ...data, cardNumber: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Amount</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.amount}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      amount: e.target.value,
                    });
                    setData({ ...data, amount: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 ">
                <p className="min-w-[250px]">Card Type</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.cardtype}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      cardtype: e.target.value,
                    });
                    setData({ ...data, cardtype: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Credit Card#</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.ccNumber}
                  readOnly
                />
              </div>

              <div className="flex py-1 px-2 ">
                <p className="min-w-[250px]">Card Holder</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.ccHolder}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      ccHolder: e.target.value,
                    });
                    setData({ ...data, ccHolder: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">CVS</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.ccv}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      ccv: e.target.value,
                    });
                    setData({ ...data, ccv: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 ">
                <p className="min-w-[250px]">Expiration Date</p>
                <div className="flex gap-[10px]">
                  <input
                    type="text"
                    className="border border-black px-2  w-[60px]"
                    value={data.ccMonth}
                    onChange={(e) => {
                      setChangedData({
                        ...changedData,
                        ccMonth: e.target.value,
                      });
                      setData({ ...data, ccMonth: e.target.value });
                    }}
                  />
                  <p>/</p>
                  <input
                    type="text"
                    className="border border-black px-2  w-[100px]"
                    value={data.ccYear}
                    onChange={(e) => {
                      setChangedData({
                        ...changedData,
                        ccYear: e.target.value,
                      });
                      setData({ ...data, ccYear: e.target.value });
                    }}
                  />
                </div>
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Billing Company</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.billingCompany}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingCompany: e.target.value,
                    });
                    setData({ ...data, billingCompany: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Billing Address</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.billingAddress}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingAddress: e.target.value,
                    });
                    setData({ ...data, billingAddress: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Billing Address2</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.billingAddress2}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingAddress2: e.target.value,
                    });
                    setData({ ...data, billingAddress2: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Billing City</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.billingCity}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingCity: e.target.value,
                    });
                    setData({ ...data, billingCity: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Billing State:</p>
                <select
                  name="state"
                  id="state"
                  className="w-[150px] border border-black"
                  value={data.billingState}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingState: e.target.value,
                    });
                    setData({ ...data, billingState: e.target.value });
                  }}
                >
                  <option value={""} disabled>
                    Select
                  </option>
                  {states.map((x, i) => (
                    <option key={i} value={x.value}>
                      {x.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Billing Zip</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.billingZip}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingZip: e.target.value,
                    });
                    setData({ ...data, billingZip: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Billing Phone</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.billingPhone}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingPhone: e.target.value,
                    });
                    setData({ ...data, billingPhone: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Billing Fax</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.billingFax}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingFax: e.target.value,
                    });
                    setData({ ...data, billingFax: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Billing Email</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.billingEmail}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      billingEmail: e.target.value,
                    });
                    setData({ ...data, billingEmail: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Ship Company</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.shipCompany}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipCompany: e.target.value,
                    });
                    setData({ ...data, shipCompany: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Ship Address</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.shipAddress}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipAddress: e.target.value,
                    });
                    setData({ ...data, shipAddress: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Ship Address2</p>
                <input
                  type="text"
                  className="border border-black px-2  w-[250px]"
                  value={data.shipAddress2}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipAddress2: e.target.value,
                    });
                    setData({ ...data, shipAddress2: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Ship City</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.shipCity}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipCity: e.target.value,
                    });
                    setData({ ...data, shipCity: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2">
                <p className="min-w-[250px]">Ship State:</p>
                <select
                  name="state"
                  id="state"
                  className="w-[150px] border border-black"
                  value={data.shipState}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipState: e.target.value,
                    });
                    setData({ ...data, shipState: e.target.value });
                  }}
                >
                  <option value={""} disabled>
                    Select
                  </option>
                  {states.map((x, i) => (
                    <option key={i} value={x.value}>
                      {x.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Ship Zip</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.shipZip}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipZip: e.target.value,
                    });
                    setData({ ...data, shipZip: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 ">
                <p className="min-w-[250px]">Ship Phone</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.shipPhone}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipPhone: e.target.value,
                    });
                    setData({ ...data, shipPhone: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">Ship Fax</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.shipFax}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipFax: e.target.value,
                    });
                    setData({ ...data, shipFax: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 ">
                <p className="min-w-[250px]">Ship Email</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.shipEmail}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      shipEmail: e.target.value,
                    });
                    setData({ ...data, shipEmail: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 bg-gray-100">
                <p className="min-w-[250px]">QB Reference#</p>
                <input
                  type="text"
                  className="border border-black px-2 w-[250px]"
                  value={data.qbRef}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      qbRef: e.target.value,
                    });
                    setData({ ...data, qbRef: e.target.value });
                  }}
                />
              </div>

              <div className="flex py-1 px-2 ">
                <p className="min-w-[250px]">Paid:</p>
                <select
                  name="paid"
                  id="paid"
                  className="w-[100px] border border-black"
                  value={data.payStatus}
                  onChange={(e) => {
                    setChangedData({
                      ...changedData,
                      payStatus: e.target.value,
                    });

                    setData({ ...data, payStatus: e.target.value });
                  }}
                >
                  <option value={1}>Paid</option>
                  <option value={0}>Not Paid</option>
                </select>
              </div>

              {id ? (
                <div className="flex justify-center mt-8 text-[14px]">
                  <button
                    onClick={() => updateContent()}
                    className="bg-[var(--color-primary-purple)] text-white border border-black px-2"
                  >
                    {" "}
                    Update ACGT Card
                  </button>
                </div>
              ) : (
                <div className="flex justify-center mt-8 text-[14px]">
                  <button
                    onClick={() => createRow()}
                    className="bg-[var(--color-primary-purple)] text-white border border-black px-2"
                  >
                    {" "}
                    Create Row
                  </button>
                </div>
              )}
            </div>

            <div className="flex justify-center mt-8 text-[14px]">
              <button
                onClick={() => window.close()}
                className="bg-[var(--color-primary-purple)] text-white border border-black px-2"
              >
                {" "}
                Close Window
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
